import SectionHead from './SectionHead';
import { hotRank } from '../data';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line',
  flat: 'ri-subtract-line',
  new: 'ri-sparkling-line',
};

const trendTone: Record<string, string> = {
  up: 'text-primary-600 bg-primary-100',
  flat: 'text-foreground-500 bg-background-200',
  new: 'text-accent-700 bg-accent-100',
};

export default function RankSection() {
  const max = hotRank[0].heat;

  return (
    <section id="rank" className="scroll-mt-20 bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <SectionHead
            eyebrow="热度榜 · 按关注攀升"
            title="这些事，正被反复翻看"
            desc="热度综合投稿量、阅读与复核请求计算。上榜越多说明想深扒的人越多，缺的证通常也越集中。"
            accent
          />
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotRank.map((r) => (
            <article
              key={r.no}
              className="flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg font-heading text-xl font-extrabold ${
                  r.no <= 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-700'
                }`}
              >
                {String(r.no).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h4 className="truncate font-heading text-base font-bold text-foreground-950">{r.name}</h4>
                  <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${trendTone[r.trend]}`}>
                    <i className={`${trendIcon[r.trend]} w-3 h-3 flex items-center justify-center`} />
                    {r.trend === 'up' ? '上升' : r.trend === 'new' ? '新上榜' : '持平'}
                  </span>
                </div>
                <div className="mt-2 flex items-center gap-3">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${Math.max(10, Math.round((r.heat / max) * 100))}%` }}
                    />
                  </div>
                  <span className="shrink-0 font-label text-xs font-semibold tabular-nums text-foreground-700">
                    {r.heat.toLocaleString()}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}